import React, { FunctionComponent, memo, ReactNode } from "react";

import { Text } from "@/components/Text";
import { Flex, IFlexProps } from "@/eworkitComponents";

interface IJobRequestDetailSectionProps extends Partial<IFlexProps> {
  label: ReactNode;
  value?: ReactNode;
  isVisible?: boolean;
}

export const JobRequestDetailSection: FunctionComponent<IJobRequestDetailSectionProps> = memo(props => {
  const { label, value, isVisible = true, grow = 1 } = props;

  if (!isVisible) {
    return null;
  }
  return (
    <Flex grow={grow} innerMargin="sm">
      <Flex direction="column">
        <Text size="md" color="grey2">
          {label}
        </Text>
        <Text size="md" color="black" wordBreak="word">
          {value}
        </Text>
      </Flex>
    </Flex>
  );
});
